import { Ticket as TicketType } from "@/types";
import { Usuario } from "@/types";

/**
 * Verifica se o usuário tem acesso ao ticket
 */
export const checkTicketAccess = (
  ticketData: TicketType,
  usuario: Usuario | null
): boolean => {
  if (!usuario || !ticketData) return false;

  if (usuario.id === ticketData.usuario_id) {
    return true;
  }

  if (ticketData.eh_mencionado === true) {
    return true;
  }

  if (usuario.nivel === "dev") {
    return true;
  }

  if (
    usuario.nivel === "admin" &&
    ticketData.departamento_id &&
    usuario.departamentos
  ) {
    const hasDepartmentAccess = usuario.departamentos.some(
      (dept) => dept.id === ticketData.departamento_id
    );
    if (hasDepartmentAccess) {
      return true;
    }
  }

  return false;
};

/**
 * Verifica se o usuário pode transferir o ticket
 */
export const canTransferTicket = (
  ticket: TicketType,
  usuario: Usuario | null
): boolean => {
  if (!usuario || !ticket) return false;

  return (
    usuario.id === ticket.usuario_id ||
    usuario.nivel === "dev" ||
    (usuario.nivel === "admin" &&
      ticket.departamento_id &&
      usuario.departamentos?.some((dept) => dept.id === ticket.departamento_id))
  );
};

/**
 * Verifica se o usuário pode fechar o ticket
 */
export const canCloseTicket = (
  ticket: TicketType,
  usuario: Usuario | null
): boolean => {
  if (!usuario || !ticket) return false;

  const usuarioEhOperador = usuario.nivel === "usuario";

  if (usuarioEhOperador) {
    if (
      ticket.departamento_id &&
      usuario.departamentos
    ) {
      return usuario.departamentos.some(
        (dept) => dept.id === ticket.departamento_id
      );
    }
    return false;
  }

  const criadorEhOperador = ticket.usuario_nivel && 
    ticket.usuario_nivel !== "admin" && 
    ticket.usuario_nivel !== "dev";

  if (usuario.id === ticket.usuario_id && criadorEhOperador) {
    if (
      ticket.departamento_id &&
      usuario.departamentos
    ) {
      return usuario.departamentos.some(
        (dept) => dept.id === ticket.departamento_id
      );
    }
    return false;
  }

  if (usuario.nivel === "dev") {
    return true;
  }

  if (
    ticket.departamento_id &&
    usuario.departamentos
  ) {
    return usuario.departamentos.some(
      (dept) => dept.id === ticket.departamento_id
    );
  }

  return false;
};

/**
 * Verifica se o usuário pode excluir o ticket
 */
export const canDeleteTicket = (
  ticket: TicketType,
  usuario: Usuario | null
): boolean => {
  if (!usuario || !ticket) return false;

  return usuario.id === ticket.usuario_id;
};

